var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[(_vm.showApp)?_c('v-container',{staticClass:"px-0"},[_c('router-view',{attrs:{"id":"router-view"}})],1):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }